import { Address } from "./address.js";
import { BitcoinAddress, BitcoinNetowkType } from "./bitcoin.js";
import { NoStrAddress } from "./nostr.js";
class AddressView extends Address {
  constructor(publicKey, network = BitcoinNetowkType.Regtest) {
    const bitcoinAddress = BitcoinAddress.fromPublicKey(publicKey, network);
    const noStrAddress = new NoStrAddress(publicKey);
    const roochAddress = bitcoinAddress.genRoochAddress();
    super(bitcoinAddress.toStr());
    this.bitcoinAddress = bitcoinAddress;
    this.noStrAddress = noStrAddress;
    this.roochAddress = roochAddress;
  }
  toBytes() {
    return this.roochAddress.toBytes();
  }
  toStr() {
    return this.roochAddress.toStr();
  }
}
export {
  AddressView
};
//# sourceMappingURL=addressView.js.map
